import { InputField, InputSelectFieldOptions } from 'components/molecules'
import { GENDER_OPTIONS } from 'domains/product/constants'

const ProductGenderFilterField = (props) => (
  <>
    <InputField
      formGroupClassName={ 'mr-3' }
      type={ 'select' }
      name={ 'gender' }
      label={ 'GENDER' }
      bsSize={ 'sm' }
      { ...props }
    >
      <InputSelectFieldOptions
        options={ GENDER_OPTIONS }
      />
    </InputField>
  </>
)

export default ProductGenderFilterField
